export const useSxStyles = () => {
  return {
    container: {
      position: 'relative',
      display: 'grid',
      gridTemplateAreas: `
        'title'
        'chart'
      `,
      gridTemplateRows: 'auto, 1fr',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '10px',
    },
    title: {
      gridArea: 'title',
      textAlign: 'center',
      margin: 0,
    },
    chart: {
      gridArea: 'chart',
    },
  };
};
